module.exports = __webpack_public_path__ + "img/bus-orange.36f2d833.svg";